// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__10ucd","detailsBorder":"styles_detailsBorder__1h6c2"};